import Head from 'next/head';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

import AppConfig from '@/utils/AppConfig';

type MetaProps = {
  blok?: any;
  title?: string;
  type?: string;
  description?: string;
  settingsGlobal?: object;
  image?: any;
};

const Meta = (props: MetaProps) => {
  const router = useRouter();

  const pathSliceLength = Math.min.apply(Math, [
    router.asPath.indexOf('?') > 0
      ? router.asPath.indexOf('?')
      : router.asPath.length,
    router.asPath.indexOf('#') > 0
      ? router.asPath.indexOf('#')
      : router.asPath.length,
  ]);

  const metaTitle = props.title;
  const metaDescription = props.description
    ? props.description
    : AppConfig.seo_description;
  const metaUrl = `${AppConfig.site_url}${router.asPath.substring(
    0,
    pathSliceLength
  )}`;
  const metaType = props.type ? props.type : 'website';

  let metaImage = [];

  if (props.image) {
    metaImage = [
      {
        url: props.image,
        alt: props.title,
        width: 1200,
        height: 630,
      },
    ];
  }

  const addJsonLd = {
    '@context': 'http://www.schema.org',
    '@type': 'LocalBusiness',
    name: 'Morgan Construction',
    url: 'https://mcel.ca/',
    telephone: '(800) 451-5636',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '4th Floor, 16901-109 Avenue',
      addressLocality: 'Edmonton',
      addressRegion: 'Alberta',
      postalCode: ' T5P 4P6',
      addressCountry: 'Canada',
    },
    openingHours: 'Mo, Tu, We, Th, Fr 09:00-17:00',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '(800) 451-5636',
    },
  };

  return (
    <>
      <Head>
        <meta charSet="UTF-8" key="charset" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1"
          key="viewport"
        />
        <link
          rel="apple-touch-icon"
          href={`${router.basePath}/apple-touch-icon.png`}
          key="apple"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${router.basePath}/favicon-32x32.png`}
          key="icon32"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${router.basePath}/favicon-16x16.png`}
          key="icon16"
        />
        <link
          rel="icon"
          href={`${router.basePath}/favicon.ico`}
          key="favicon"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(addJsonLd),
          }}
          key="item-jsonld"
        />
      </Head>
      <NextSeo
        title={metaTitle}
        titleTemplate={`${AppConfig.seo_title} • %s`}
        defaultTitle={AppConfig.seo_title}
        description={metaDescription}
        noindex={props.blok?.seo_noindex}
        openGraph={{
          type: metaType,
          title: metaTitle,
          description: metaDescription,
          url: metaUrl,
          site_name: AppConfig.site_name,
          images: metaImage,
        }}
      />
    </>
  );
};

export default Meta;
